import { TitularTooltip } from '@campfire/titular-tooltip';
import { DraggableList, DraggableListItem, DraggableListItemHandle } from '@campfire/draggable-list';
import React from 'react';
import { useFormikContext } from 'formik';
import { ListItem, Grid, IconButton, Typography, Box } from '@material-ui/core';
import { Star as StarIcon, Clear as ClearIcon } from '@material-ui/icons';
import { unpackToDate } from '@campfire/hot-date';
import { CategoryEditorInitialValues } from './CategoryEditor';
import { useCampfireTheme } from '../../../../theme/useCampfireTheme';

const CategoryEditorResourcesList = () => {
  const { values, setFieldValue } = useFormikContext<CategoryEditorInitialValues>();
  const { theme } = useCampfireTheme();

  const handleToggleFeatured = (idx: number) => {
    const resource = values.categoryResources[idx];
    const updated = [...values.categoryResources];
    updated[idx] = { ...resource, featured: !resource.featured };
    setFieldValue('categoryResources', updated);
  };

  const handleRemove = (idx: number) => {
    const updated = values.categoryResources.filter((_unused, i) => i !== idx);
    setFieldValue('categoryResources', updated);
  };

  return (
    <DraggableList
      onReorder={(startIdx, endIdx, reorderFn) => {
        setFieldValue('categoryResources', reorderFn(values.categoryResources, startIdx, endIdx));
      }}
    >
      {values.categoryResources.map((resource, idx) => (
        <DraggableListItem
          key={resource.supportResourceId}
          id={resource.supportResourceId}
          index={idx}
          style={{ padding: 0 }}
        >
          <Box display='flex' alignItems='center' width='100%'>
            <Box display='flex' alignItems='center' style={{ cursor: 'grab', paddingRight: 4 }}>
              <DraggableListItemHandle style={{ fontSize: 18, color: '#bbb' }} />
            </Box>
            <ListItem
              style={{
                borderBottom:
                  idx !== values.categoryResources.length - 1 ? `1px solid ${theme.color.grey.border}` : 'unset',
                padding: '8px 0px',
                flex: 1,
              }}
            >
              <Grid container alignItems='center' spacing={1}>
                <Grid item>
                  <IconButton
                    data-track='resources-category-editor-resource-list-item-favourite-button'
                    onClick={() => handleToggleFeatured(idx)}
                  >
                    <StarIcon style={{ color: resource.featured ? theme.color.starYellow : 'inherit' }} />
                  </IconButton>
                </Grid>
                <Grid item container direction='column' xs style={{ overflow: 'hidden' }}>
                  <Grid item>
                    <Typography variant='body1'>{resource.title}</Typography>
                  </Grid>
                  <Grid item>
                    <Typography variant='body2' color='textSecondary'>{`Uploaded on ${unpackToDate(
                      resource.dateAdded
                    ).toFormat('dd MMM yyyy')}`}</Typography>
                  </Grid>
                </Grid>
                <Grid item>
                  <TitularTooltip description='Delete Resource'>
                    <IconButton
                      data-track='resources-category-editor-resource-list-item-delete-button'
                      onClick={() => handleRemove(idx)}
                    >
                      <ClearIcon color='error' />
                    </IconButton>
                  </TitularTooltip>
                </Grid>
              </Grid>
            </ListItem>
          </Box>
        </DraggableListItem>
      ))}
    </DraggableList>
  );
};

export { CategoryEditorResourcesList };
